"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_class_component_1 = __importDefault(require("vue-class-component"));
var ViewWindow_vue_1 = __importDefault(require("./ViewWindow.vue"));
var request_1 = __importDefault(require("../request"));
var VContributionStatus_vue_1 = __importDefault(require("./scraps/VContributionStatus.vue"));
var VSimpleContributionStatus_vue_1 = __importDefault(require("./scraps/VSimpleContributionStatus.vue"));
var vue_class_component_2 = require("vue-class-component");
var EchoMixin_1 = __importDefault(require("../mixins/request/EchoMixin"));
var TheStatus = /** @class */ (function (_super) {
    __extends(TheStatus, _super);
    function TheStatus() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "the-status";
        _this.registrationNumber = "";
        _this.amounts = [];
        _this.profile = [];
        _this.lastModified = null;
        _this.transferDetails = null;
        _this.remarks = null;
        return _this;
    }
    TheStatus.prototype.created = function () {
        var registrationNumber = this.$route.params["registrationNumber"];
        this.registrationNumber = registrationNumber;
        this.echo.channel(this.echoChannels.status + "." + registrationNumber)
            .listen(this.echoEvents.status.update, this.requestStatus);
        this.requestStatus();
    };
    TheStatus.prototype.beforeDestroy = function () {
        this.echo.leave(this.echoChannels.status + "." + this.registrationNumber);
    };
    TheStatus.prototype.requestStatus = function () {
        request_1.default.contribution
            .status(this.registrationNumber, this.updateContributionsStatus)
            .then(this.redirect);
    };
    Object.defineProperty(TheStatus.prototype, "years", {
        get: function () {
            var _a = this.$store.state.settings, CONTRIBUTIONS_YEAR_START = _a.CONTRIBUTIONS_YEAR_START, CONTRIBUTIONS_YEAR_END = _a.CONTRIBUTIONS_YEAR_END;
            var results = [];
            for (var i = CONTRIBUTIONS_YEAR_START; i <= CONTRIBUTIONS_YEAR_END; i++) {
                results.push(i);
            }
            return results;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TheStatus.prototype, "arrears", {
        get: function () {
            if (typeof this.profile.arrears !== "undefined") {
                return this.profile.arrears.total;
            }
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    TheStatus.prototype.getAmountForYearAndQuarter = function (year, quarter) {
        return (typeof this.amounts[year] !== "undefined" && typeof this.amounts[year]["quarter" + quarter] !== "undefined")
            ? this.amounts[year]["quarter" + quarter] + " zł"
            : "";
    };
    TheStatus.prototype.getStatusForYearAndQuarter = function (year, quarter) {
        if (this.profile["status"]) {
            return this.profile["status"][year]["quarter" + quarter];
        }
        return "not-applicable";
    };
    TheStatus.prototype.updateContributionsStatus = function (amounts, profile, lastModified, transferDetails, remarks) {
        this.amounts = amounts;
        this.profile = profile;
        this.lastModified = lastModified;
        this.transferDetails = (transferDetails === null || transferDetails === void 0 ? void 0 : transferDetails.replace(/\n/g, "<br>")) || null;
        this.remarks = remarks;
    };
    TheStatus.prototype.redirect = function () {
        if (typeof this.profile["status"] === "undefined") {
            this.$router.push(this.$views.Home.path);
        }
    };
    TheStatus = __decorate([
        vue_class_component_1.default({ components: {
                VSimpleContributionStatus: VSimpleContributionStatus_vue_1.default,
                VContributionStatus: VContributionStatus_vue_1.default,
                ViewWindow: ViewWindow_vue_1.default
            } })
    ], TheStatus);
    return TheStatus;
}(vue_class_component_2.mixins(EchoMixin_1.default)));
exports.default = TheStatus;
